import { useSelector } from "react-redux";
import useToolbarSetter from "../../hooks/Common/useToolbarSetter";
import { RootState } from "../../redux/store";
import { cameraDetectionInList } from "../../web_api/models";
import CommonNewUserCard from "../Common/CommonNewUserCard";
import DetectionAdd from "./DetectionAdd";

type DetectionNewUserCardsProps = {
    dataLength: number,
    show: boolean,
    onDetectionAdd: (detection: cameraDetectionInList) => void;
    toggleModal: () => void
};

const DetectionNewUserCards: React.FC<DetectionNewUserCardsProps> = ({

    dataLength,
    show,
    toggleModal,
    onDetectionAdd

}) => {

    const cachedCameraList = useSelector((state: RootState) => state.camerasList.list);
    const cachedLocationsList = useSelector((state: RootState) => state.cachedLocations.list);
    const cachedCameraModelList = useSelector((state: RootState) => state.cameraModelList.list);
    const cachedDetectionServerList = useSelector((state: RootState) => state.detectionServerList.list);

    const { setToolbar } = useToolbarSetter();

    return (
        <>
            <div className="container py-3 py-lg-6 px-6 px-md-20 mb-6">
                {dataLength === 0 &&
                    cachedLocationsList.length > 0 &&
                    cachedCameraList.length > 0 &&
                    cachedCameraModelList.length > 0 &&
                    cachedDetectionServerList.length > 0 ? (
                    <DetectionAdd
                        onDetectionAdd={onDetectionAdd}
                        dataLength={dataLength}
                        show={show}
                        toggleModal={toggleModal}
                    />
                ) : null}
                <div className="row row-cols-xl-2 g-5 justify-content-space-between">

                    {cachedDetectionServerList.length === 0 ? (
                        <div className="mx-auto" style={{ minHeight: '450px' }}>
                            <CommonNewUserCard
                                title="Get started with detections!"
                                content={`Before you can add detections, you must add a detection server.\n
                                                    Click on this card and follow the instructions to get started.`}
                                className="h-100"
                                icon="bi bi-hdd-network"
                                link={`${process.env.REACT_APP_HOMEPAGE}/detection-servers`}
                                buttonText="To Servers"
                                onClick={() => setToolbar("detection-servers", "Detection Servers")}
                            />
                        </div>
                    ) : null}

                    {cachedCameraList.length === 0 ? (
                        <div className="mx-auto" style={{ minHeight: '450px' }}>
                            <CommonNewUserCard
                                title="Get started with detections!"
                                content={`Before you can add detections, you must add a camera.\n
                                    Click on this card and follow the instructions to get started`}
                                className="h-100"
                                icon="bi bi-camera"
                                link={`${process.env.REACT_APP_HOMEPAGE}/cameras`}
                                buttonText="To Cameras"
                                onClick={() => setToolbar('cameras', "Cameras")}
                            />
                        </div>
                    ) : null}

                    {cachedLocationsList.length === 0 ? (
                        <div style={{ minHeight: '450px' }}>
                            <CommonNewUserCard
                                title="Get started with detections!"
                                content={`Before you can add detections, you must add a location.\n
                                    Click on this card and follow the instructions to get started.`}
                                className="h-100"
                                icon="bi bi-houses"
                                link={`${process.env.REACT_APP_HOMEPAGE}/locations`}
                                buttonText="To Locations"
                                onClick={() => setToolbar('locations', "Locations")}
                            />
                        </div>

                    ) : null}

                    {cachedCameraModelList.length === 0 ? (
                        <div style={{ minHeight: '450px' }}>
                            <CommonNewUserCard
                                title="Get started with detections!"
                                content={`Before you can add detections, you must add a camera model.\n
                                        Click on this card and follow the instructions to get started.`}
                                className="h-100"
                                icon="bi bi-collection"
                                link={`${process.env.REACT_APP_HOMEPAGE}/camera-models`}
                                buttonText="To Models"
                                onClick={() => setToolbar("camera-models", "Camera Models")}
                            />
                        </div>
                    ) : null}
                </div>

            </div>

        </>

    )
}

export default DetectionNewUserCards;